import styled from 'styled-components';
import Image from 'next/image';
import {getColor} from "@/styles/ThemeConfig";
import Stars from "@/components/base/Stars";
import {Button} from "@/components/base/Buttons";
import TagHeartIcon from '/public/images/tag-heart.svg';
import TagChocolateIcon from '/public/images/tag-chocolate.svg';
import TagStarIcon from '/public/images/tag-star.svg';
import TagVipIcon from '/public/images/vip.svg';
import FlagIcon from '/public/images/tag-favourite.svg';
import ForceSSRLink from "@/components/other/ForceSSRLink";


import ClockIcon from '/public/images/clock.svg';
import LocationMaincolorIcon from '/public/images/location-maincolor.svg';
import CutleryIcon from '/public/images/cutlery.svg';
import GroupIcon from '/public/images/group.svg';

import TagChefIcon from '/public/images/tag-chef.svg';
import TagClassicIcon from '/public/images/tag-classic.svg';
import TagHatIcon from '/public/images/tag-hat.svg';

// Styled Components
const CardContainer = styled.div`
  width: 100%;
  background-color: #fafafa;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
    
    position: relative;
`;

const CardImage = styled(Image)`
  width: 100%;
  height: 250px;
  object-fit: cover;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
    padding:10px;
    padding-bottom: 120px;
`;

const RatingContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const RatingDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

const Price = styled.div`
  flex-basis: content;
  font-family: 'Josefin Sans';
  font-size: 30px;
  color: ${getColor('grayText')};
`;

// Deliberately not a heading. These cards sit in a Slick carousel with the
// infinite loop on, and Slick clones slide nodes at both ends of the track, so a
// heading here is cloned with them: five tours rendered thirteen H3s. The grid of
// tours on a city page uses CityTourCard instead and keeps its headings, since
// nothing is cloned there.
const Title = styled.div`
  padding: 5px 5px 0px 0;
  font-family: 'Playfair Display';
  font-size: 23px;
  line-height: 24px;
`;

const Description = styled.p`
  font-size: 14px;
    font-family: 'Inter';
`;

const TagsWrapper = styled.div`
    display: flex;
    gap:10px;
    flex-wrap: wrap;
`

const TagContainer = styled.div`
  background-color: #161616;
  border-radius: 30px;
  padding: 3px 12px;
  color: white;
  font-size: 14px!important;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
`;

const InfoContainer = styled.div`
    margin:10px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
    row-gap: 0;
    justify-content: center;
`;

const InfoItem = styled.div`
    color: ${getColor('greenText')};
    font-size: 14px;
  display: flex;
  align-items: center;
  gap: 5px;
    font-family: 'Inter';
`;

const LearnMoreButton = styled.a`
 text-decoration: underline;
    color: ${getColor('greenText')};
    text-align: center;
`;

const ButtonsContainer = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 5px;

    
    position: absolute;
    left:10px;
    bottom: 20px;
    width: calc(100% - 20px);
`;




// Main Component
export default function VariantBCityTourCard({ item, ...rest }) {
    return (
        <CardContainer {...rest}>
            <ForceSSRLink prefetch={false} href={item?.slug}>
                <CardImage src={item?.cardImage?.url} alt={item?.cardTitle ?? item?.title} width="400" height="250" />
            </ForceSSRLink>

            <CardContent>
                <RatingContainer>
                    <RatingDetails>
                        <Stars style={{color: getColor('yellow')}} numOfStars={item?.data?.info?.rating} size={25}/>
                        <span style={{
                            fontSize: '14px',
                            paddingLeft: '10px',
                            paddingTop: '3px',
                            color: 'gray'
                        }}>({item?.data?.info?.rating})</span>
                    </RatingDetails>

                    <Price>{item?.data?.info?.currency ?? '€'}{item?.data?.info?.price}</Price>
                </RatingContainer>

                <Title>{item?.cardTitle ?? item?.title}</Title>

                <TagsWrapper>
                    {item?.data?.info?.tags?.map((item, index) => {
                        return <TagContainer
                            key={index}
                        >
                            {item?.icon === 'icon_1' && <Image src={TagHeartIcon} width="20" alt="Heart Tag"/>}
                            {item?.icon === 'icon_2' && <Image src={TagChocolateIcon} width="20" alt="Chocolate Tag"/>}
                            {item?.icon === 'icon_3' && <Image src={TagStarIcon} width="20" alt="Star Tag"/>}
                            {item?.icon === 'icon_4' && <Image src={TagVipIcon} width="20" alt="Vip Tag"/>}
                            {item?.icon === 'icon_5' && <Image src={FlagIcon} width="20" alt="Flag Tag"/>}
                            {item?.icon === 'icon_6' && <Image src={TagChefIcon} width="20" alt="Chef Tag"/>}
                            {item?.icon === 'icon_7' && <Image src={TagClassicIcon} width="20" alt="Classic Tag"/>}
                            {item?.icon === 'icon_8' && <Image src={TagHatIcon} width="20" alt="Hat Tag"/>}
                            {item?.text}
                        </TagContainer>
                    })
                    }
                </TagsWrapper>
                <Description dangerouslySetInnerHTML={{__html: ((item?.data?.info?.description || "").replace(/<\/?[^>]+(>|$)/g, ""))}}/>



                <InfoContainer>

                    {item?.data?.info?.duration && <InfoItem>
                        <Image src={ClockIcon} alt="Duration"/>
                        {item?.data?.info?.duration}
                    </InfoItem>}
                    {item?.data?.info?.location && <InfoItem>
                        <Image src={LocationMaincolorIcon} alt="Location"/>
                        {item?.data?.info?.location}
                    </InfoItem>}
                    {item?.data?.info?.numOfStops && <InfoItem>
                        <Image src={CutleryIcon} alt="Stops"/>
                        {item?.data?.info?.numOfStops} {item?.data?.info?.stopsText ?? 'stops'}
                    </InfoItem>}
                    {item?.data?.info?.numOfPeople && <InfoItem>
                        <Image src={GroupIcon} alt="Max People"/>
                        {item?.data?.info?.numOfPeople} {item?.data?.info?.peopleText ?? 'people max'}
                    </InfoItem>}
                </InfoContainer>
            </CardContent>



            <ButtonsContainer>
                <Button variant={'green'} href={item?.slug} style={{width:'100%', minHeight:'50px'}}>BOOK NOW</Button>
                <LearnMoreButton href={item?.slug} style={{color:'black', fontFamily:'Poppins', fontSize:'15px'}}>Learn More</LearnMoreButton>
            </ButtonsContainer>

        </CardContainer>
    );
}
